/* eslint-disable max-len */
import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// local image assets
import financialPlanningImageDesktopWebp from './images/business-woman-desktop.webp';
import financialPlanningImageMobileWebp from './images/business-woman-tablet.webp';
// styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='special-needs-planning-financial-planning'
      themeType='lightTheme'
      backgroundVariant='lightC'
      moduleName='financial-planning-module'
      moduleVariation='A'
      disableBottomPadding={false}
      reverseContent={false}
      // content
      subHeadingText={<>Why work with a special <WidowBlock>needs advisor&#63;</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Our advisors have the specialized skills needed to help you navigate the unique considerations that come with caring for a loved one with special needs. They&#39;ll assemble the right team that may include experts in law, social services, and more to help with:
          </Typography>
          <BulletedListStyled
            disableBottomPadding
            bulletedListData={[
              { bulletText: 'Estate planning' },
              { bulletText: 'Special needs trusts' },
              { bulletText: 'Life insurance' },
              { bulletText: 'Tax deductions' },
              { bulletText: 'Healthcare issues' },
              { bulletText: 'Medicaid complexities' },
            ]}
            bulletType='checkmark'
          />
        </>
      )}
      // image props
      imageAltText='A business woman in a business suit.'
      imageSrcDefault={financialPlanningImageDesktopWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};
